function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _ENGLISH_EXAM_INPUT_V, _STANDARD_TEST_INPUT_;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import { ENGLISH_EXAM_TYPE_VALUES, ENGLISH_EXAM_INPUT_TYPES } from "../../../../EnglishTests/consts";
import { STANDARD_TEST_TYPE_VALUES, STANDARD_TEST_INPUT_TYPES } from "../../../../StandardizedTests/consts";
export var EDUCATION_DISPLAY = {
  grade_1: 'Grade 1',
  grade_2: 'Grade 2',
  grade_3: 'Grade 3',
  grade_4: 'Grade 4',
  grade_5: 'Grade 5',
  grade_6: 'Grade 6',
  grade_7: 'Grade 7',
  grade_8: 'Grade 8',
  grade_9: 'Grade 9',
  grade_10: 'Grade 10',
  grade_11: 'Grade 11',
  highschool: 'Grade 12',
  certificate: 'Certificate',
  diploma: 'Diploma',
  advanced_diploma: 'Advanced Diploma',
  '3_year_bachelors': '3 Year Bachelors',
  bachelors: 'Bachelors',
  post_graduate: 'Post Graduate',
  masters: 'Masters',
  doctoral: 'Doctoral',
  EDUCATION_MISSING: 'Education Missing'
};
export var BACKEND_TO_FRONTEND_MAP = {
  listening: 'l',
  reading: 'r',
  speaking: 's',
  writing: 'w',
  total: 'total',
  average: 'average'
};
export var ENGLISH_EXAM_INPUT_VALUES_DISPLAY = (_ENGLISH_EXAM_INPUT_V = {}, _defineProperty(_ENGLISH_EXAM_INPUT_V, ENGLISH_EXAM_TYPE_VALUES.TOEFL, new Set([ENGLISH_EXAM_INPUT_TYPES.LISTENING, ENGLISH_EXAM_INPUT_TYPES.READING, ENGLISH_EXAM_INPUT_TYPES.WRITING, ENGLISH_EXAM_INPUT_TYPES.SPEAKING, 'total'])), _defineProperty(_ENGLISH_EXAM_INPUT_V, ENGLISH_EXAM_TYPE_VALUES.IELTS, new Set([ENGLISH_EXAM_INPUT_TYPES.LISTENING, ENGLISH_EXAM_INPUT_TYPES.READING, ENGLISH_EXAM_INPUT_TYPES.WRITING, ENGLISH_EXAM_INPUT_TYPES.SPEAKING, 'average'])), _defineProperty(_ENGLISH_EXAM_INPUT_V, ENGLISH_EXAM_TYPE_VALUES.DUOLINGO, new Set(undefined)), _defineProperty(_ENGLISH_EXAM_INPUT_V, ENGLISH_EXAM_TYPE_VALUES.PTE, new Set(undefined)), _ENGLISH_EXAM_INPUT_V);
export var STANDARD_TEST_INPUT_VALUES_DISPLAY = (_STANDARD_TEST_INPUT_ = {}, _defineProperty(_STANDARD_TEST_INPUT_, STANDARD_TEST_TYPE_VALUES.GMAT, new Set([STANDARD_TEST_INPUT_TYPES.QUANTITATIVE, STANDARD_TEST_INPUT_TYPES.QUANTITATIVE_RANK, STANDARD_TEST_INPUT_TYPES.VERBAL, STANDARD_TEST_INPUT_TYPES.VERBAL_RANK, STANDARD_TEST_INPUT_TYPES.WRITING, STANDARD_TEST_INPUT_TYPES.WRITING_RANK])), _defineProperty(_STANDARD_TEST_INPUT_, STANDARD_TEST_TYPE_VALUES.GRE, new Set([STANDARD_TEST_INPUT_TYPES.QUANTITATIVE, STANDARD_TEST_INPUT_TYPES.QUANTITATIVE_RANK, STANDARD_TEST_INPUT_TYPES.VERBAL, STANDARD_TEST_INPUT_TYPES.VERBAL_RANK, STANDARD_TEST_INPUT_TYPES.WRITING, STANDARD_TEST_INPUT_TYPES.WRITING_RANK, 't'])), _STANDARD_TEST_INPUT_);